/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import React from 'react';
import Popper from '@mui/material/Popper';
import {ComponentPaperAutocomplete, CustomPopperAutocompleteStyle} from "./Styles";
import Paper from "@mui/material/Paper";


export const CustomPopperAutocomplete = (props) => {
    return (
        <Popper
            {...props}
            style={CustomPopperAutocompleteStyle}
            placement="bottom-start"
            // Fixed strategy keeps the options list out of the document flow, so opening it
            // near the bottom of the page cannot grow the document and toggle the scrollbar
            popperOptions={{ strategy: 'fixed' }}
            modifiers={[
                {
                    // The whole gap between the input and the list lives here: a CSS margin on
                    // the popper is measured after positioning and makes flip oscillate
                    name: 'offset',
                    options: {
                        offset: [0, 20],
                    },
                },
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-start'],
                        padding: 8,
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        tether: false,
                        padding: 8,
                    },
                },
                {
                    name: "sameWidth",
                    enabled: true,
                    phase: "beforeWrite",
                    requires: ["computeStyles"],
                    fn: ({ state }) => {
                        if (state.rects.reference.width < 400 ) {
                            state.styles.popper.width = `${state.rects.reference.width}px`;
                        } else {
                            state.styles.popper.width = CustomPopperAutocompleteStyle.customWidth;
                        }
                    },
                },
            ]}
        />
    );
};

export const CustomPaperAutocomplete = (props) => {
    return <Paper
        {...props}
        elevation={3}
        square={false}
        sx={ComponentPaperAutocomplete}
    />;
};
